import { AnimatePresence, motion } from "motion/react";
import type { ReactNode } from "react";

export function ToastMotionGroup({ children }: { children: ReactNode }): ReactNode {
  return <AnimatePresence>{children}</AnimatePresence>;
}

export function ToastMotionItem({ children }: { children: ReactNode }): ReactNode {
  return (
    <motion.div
      className="pointer-events-auto"
      initial={{ y: -16, scale: 0.4 }}
      animate={{ y: 0, scale: 1 }}
      exit={{ y: -16, scale: 0.6 }}
      layout
    >
      {children}
    </motion.div>
  );
}
